import jwtDecode from "jwt-decode";

export const checkTokenExp = (token) => {
  if (!token) {
    return false;
  }
  
  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now();
    const expirationTime = decoded.exp * 1000;
    
    if (expirationTime < currentTime) {
      return false;
    }
    return true;
  } catch (error) {
    console.log("Token decode error:", error);
    return false;
  }
};

export const logout = () => {
  localStorage.clear();
  window.location.href = "/auth/login";
};

export default checkTokenExp;
